<template>
  <diV class="content">
    <div v-if="provinceList" class="province">
      <div v-for="(pro, index) in provinceList" :class="['province-item', index === proIndex ? 'select-pro' : '']" :key="pro.id" @click="selectPro(index, pro.name, pro.id)">{{pro.name}}</div>
    </div>
    <div v-if="cityList" class="city">
      <div :class="['city-item', index === cityIndex ? 'select-city' : '']" v-for="(city, index) in cityList" :key="city.id" @click="selectCity(index, city.name, city.id)">{{city.name}}</div>
    </div>
  </diV>
</template>
<script>
import { getCities } from '@/http/api'
export default {
  data () {
    return {
      provinceList: null,
      cityList: null,
      districtList: null,
      proIndex: null,
      cityIndex: null,
      pickCity: {
        cityIndex: [],
        cityName: [],
        cityid: []
      }
    }
  },

  methods: {
    // 获取全部城市
    getCity () {
      let data = {
        token: localStorage.token
      }
      getCities(data).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.provinceList = res.data
          localStorage.setItem('provinceList', JSON.stringify(res.data))
          this.changeCity()
        } else {
          console.log(res.msg)
        }
      })
    },

    // 如果有记录自动选择上一次的结果
    changeCity () {
      let pickCity = localStorage.pickCity
      if (pickCity) {
        pickCity = JSON.parse(pickCity)
        this.proIndex = pickCity.cityIndex[0]
        this.cityList = this.provinceList[pickCity.cityIndex[0]].list
        this.cityIndex = pickCity.cityIndex[1]
        this.pickCity = pickCity
      } else {
        this.cityIndex = 0
        this.cityList = this.provinceList[0].list
        this.proIndex = 0
        this.districtList = null
        this.pickCity.cityIndex.push(0)
        this.pickCity.cityName.push(this.provinceList[0].name)
        this.pickCity.cityid.push(this.provinceList[0].id)
        this.pickCity.cityIndex[1] = 0
        this.pickCity.cityName[1] = this.cityList[0].name
        this.pickCity.cityid[1] = this.cityList[0].id
        localStorage.setItem('pickCity', JSON.stringify(this.pickCity))
        console.log(this.pickCity)
      }
    },

    // 选择省份
    selectPro (index, name, id) {
      this.pickCity = {
        cityIndex: [],
        cityName: [],
        cityid: []
      }
      console.log(index, name, id)
      this.cityIndex = 0
      this.cityList = this.provinceList[index].list
      this.proIndex = index
      this.districtList = null
      this.pickCity.cityIndex.push(index)
      this.pickCity.cityName.push(name)
      this.pickCity.cityid.push(id)
    },

    // 选择城市
    selectCity (index, name, id) {
      this.districtList = this.cityList[index].list
      this.cityIndex = index
      console.log(this.cityIndex)
      this.pickCity.cityIndex[1] = index
      this.pickCity.cityName[1] = name
      this.pickCity.cityid[1] = id
      localStorage.setItem('pickCity', JSON.stringify(this.pickCity))
      this.$router.push({
        path: '/apply'
      })
    }
  },

  mounted () {
    let provinceList = localStorage.provinceList
    if (provinceList) {
      provinceList = JSON.parse(provinceList)
      this.provinceList = provinceList
      this.changeCity()
    } else {
      this.getCity()
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin flex ($flex) {
  flex: $flex;
  text-align: center;
  font-size: .3rem;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}
.content {
  font-size: 0;
  display: -webkit-flex;
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

.province {
  @include flex(1);
  background: #f5f5f5;
  .province-item {
    height: .9rem;
    line-height: .9rem;
  }
  .select-pro {
    background: #fff;
    color: #01B389;
  }
}

.city {
  @include flex(2);
  box-shadow: 0px 2px 30px 0px rgba(212, 212, 212, 0.3);
  .city-item {
    height: .9rem;
    line-height: .9rem;
  }
  .select-city {
    color: #01B389;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cities/Cities.vue